import React from 'react'

export default class PreMissionShow extends React.Component {

  _labelRemainingRepeats = (remainingRepeats) => {
    if (remainingRepeats === 1) {
      return `Queda ${remainingRepeats} envío hoy`
    } else if (remainingRepeats > 1) {
      return `Quedan ${remainingRepeats} envíos hoy`
    }
    return 'No quedan envíos hoy'
  }

  render() {
    const { daily_done_repeats, daily_max_repeats } = this.props
    if (daily_max_repeats <= 1) {
      return null
    }
    return (
      <p>Nota: {this._labelRemainingRepeats(daily_max_repeats - daily_done_repeats)}</p>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/CampaignShow/RemainingRepeats/index.jsx